<template>
    <div class="addContextMenu" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <a-card class="search-results-card">
            <div style="display: flex; flex-direction: row; justify-content: center; padding: 10px 30px">
                <span
                    style="
                        display: flex;
                        flex-direction: row;
                        justify-content: end;
                        text-align: center;
                        align-items: center;
                    "
                >
                    <a-icon style="font-size: 23px !important" type="search" />
                </span>
                <input
                    ref="focusMe"
                    style="padding: 0 10px"
                    id="context-search"
                    type="search"
                    :placeholder="$t('chatbotv2.search')"
                    v-model="query"
                    @keypress.13="focusAndNavigate(selectedIndex)"
                    @keyup.40="inputArrowDown()"
                    @keydown.38="inputArrowUp()"
                />
                <span
                    style="
                        display: flex;
                        flex-direction: row;
                        justify-content: end;
                        text-align: center;
                        align-items: center;
                    "
                >
                    <a-icon style="font-size: 21px" type="close" v-if="bar !== 0" @click="$emit('close-menu', 0)" />
                </span>
            </div>
            <div class="searching-results" v-if="query.length > 2">
                <button
                    @click="selectByClick(action)"
                    :autofocus="i === selectedIndex"
                    class="search-results-btn"
                    :class="{ selected: i === selectedIndex }"
                    :id="`search-results-btn-id${i}`"
                    v-for="(action, i) in resultList"
                    @keypress.13="focusAndNavigate(selectedIndex)"
                    @mouseover="onlyFocusOn(action)"
                >
                    <div class="search-results-btn-child">
                        <BlockIconPreview :block-type="action.type" class="block-icon-preview-search" />
                        <div style="display: flex; flex-direction: column; text-align: start">
                            <div>
                                {{ $t(`chatbotv2.${action.type}`) }}
                            </div>
                            <div style="font-weight: 700" :id="`block-name-id${i}`">{{ action.name }}</div>
                        </div>
                    </div>
                </button>
            </div>
            <div class="searching-results" style="background: #e8eef3" v-else-if="query.length > 0">
                <div class="search-results-less-char">
                    <p style="color: #516173" class="search-results-btn-child">
                        {{ $t("chatbotv2.typeMoreThan3Char") }}
                    </p>
                </div>
            </div>
            <div
                class="searching-results"
                style="background: #e8eef3"
                v-if="query.length > 2 && resultList.length <= 0"
            >
                <div class="search-results-less-char">
                    <p style="color: #516173" class="search-results-btn-child">{{ $t("chatbotv2.noMatchingItem") }}</p>
                </div>
            </div>
        </a-card>
        <a-card class="hint-footer" v-if="query.length > 2 && resultList.length > 0">
            <div
                class="hint-content"
                style="display: flex; flex-direction: row; justify-content: center; align-items: center"
            >
                <span class="" style="margin-right: 5px; padding-right: 10px">{{ $t("chatbotv2.hint") }}:</span>
                <span class="" style="margin-right: 5px; padding-right: 10px">
                    <a-icon type="arrow-up" /><a-icon type="arrow-down" /> {{ $t("chatbotv2.navigate") }}
                </span>
                <span class="" style="margin-right: 5px; padding-right: 10px">
                    <a-icon type="enter" /> {{ $t("chatbotv2.select") }}
                </span>
                <span class="" style="margin-right: 5px; padding-right: 10px">ESC {{ $t("chatbotv2.dismiss") }}</span>
            </div>
        </a-card>
    </div>
</template>

<script>
import _ from "lodash";
import Fuse from "fuse.js";
import { log2 } from "../../../../../../utils/log2";
import { ActionPalette } from "../../../BlockConfiguration";
import SYSTEM_PUBSUB from "../../../../../../utils/systemPubSub";
import { mapActions, mapMutations } from "vuex";
import BlockIconPreview from "../common/BlockIconPreview";

const log = log2("SearchWidget");

export default {
    name: "SearchWidget",
    components: {
        BlockIconPreview,
    },
    props: ["flattedDiagram", "blocksMetas", "bar", "automation", "navigateTo"],
    data() {
        return {
            ActionPalette,
            query: "",
            control: 0,
            selectedIndex: null,
            resultList: [],
        };
    },
    methods: {
        ...mapActions({}),
        getFilteredItems(query) {
            log("getFilteredItems this.flattedDiagram", this.flattedDiagram);
            let list = this.flattedDiagram.map((x) => ({
                ...x,
                localizedType: `${this.$t("chatbotv2." + x.type)}`,
                payloadString: JSON.stringify(x.payload),
            }));
            const options = {
                keys: ["type", "localizedType", "payloadString", "name"],
            };
            const fuzzySearch = new Fuse(list, options);

            const results = query.length > 0 ? fuzzySearch.search(query).map((x) => x.item) : list;

            return results.slice(0, 5);
        },
        search() {
            if (this.query.length > 2) {
                const result = this.getFilteredItems(this.query);
                this.selectedIndex = !!result.length ? 0 : null;
                this.resultList = result;
            } else {
                this.selectedIndex = null;
                this.resultList = [];
            }
        },
        onlyFocusOn(block) {
            const isTheBlock = (element) => element.id === block.id;
            this.selectedIndex = this.resultList.findIndex(isTheBlock);
        },
        selectByClick(block) {
            if (!!block.parent && !!block.parent.parent) this.focusCollapsedBlock(block);
            else {
                const pathname = `${window.location.pathname}`;
                if (pathname.includes("/flow/")) {
                    this.navigateTo(null);
                }
            }
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_FOCUS_BLOCK, {
                blockId: _.get(block, "id"),
            });
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_SELECT_BLOCK, {
                blockId: _.get(block, "id"),
            });
            const isTheBlock = (element) => element.id === block.id;
            this.selectedIndex = this.resultList.findIndex(isTheBlock);
        },
        focusAndNavigate(index) {
            const block = this.resultList[index];
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_FOCUS_BLOCK, {
                blockId: _.get(block, "id"),
            });
        },
        inputArrowDown() {
            if (this.selectedIndex < this.resultList.length - 1) this.selectedIndex += 1;
        },
        inputArrowUp() {
            if (this.selectedIndex > 0) this.selectedIndex -= 1;
        },
        focusCollapsedBlock(block) {
            //todo refactor
        },
    },
    mounted() {
        this.$nextTick(() => this.$refs.focusMe.focus());
    },
    beforeDestroy() {
        SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_SELECT_BLOCK, {
            blockId: null,
        });
    },
    watch: {
        query(newVal) {
            this.search();
        },
        selectedIndex(index) {
            const currentBlock = this.resultList[index];
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_SELECT_BLOCK, {
                blockId: _.get(currentBlock, "id"),
            });
        },
        resultList: {
            deep: true,
            handler: function (newList) {
                const currentBlock = newList[this.selectedIndex];

                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_SELECT_BLOCK, {
                    blockId: _.get(currentBlock, "id"),
                });
            },
        },
    },
};
</script>
<style lang="scss">
.search-results-card {
    .ant-card-body {
        padding: unset !important;
    }
}
</style>

<style lang="scss" scoped>
.addContextMenu {
    color: #000000;
    top: 1rem;
    right: 0.1rem !important;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: 80vh;
    position: absolute;
    max-width: 400px;
    z-index: 9999;
    border-radius: 16px;
    box-shadow: 0 4px 20px #00000040;
    padding: 0 !important;

    .hint-footer {
        -ms-flex-negative: 0;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        align-items: center;
        background: #475e7a;
        border-radius: 10px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        flex-shrink: 0;
        height: 47px;
        justify-content: center;
        margin-top: 13px;

        .hint-content {
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            color: #fff;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            font-size: 12px;
            line-height: 17px;
        }
    }

    .search-results-card {
        padding: unset !important;
        zoom: 1;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        max-height: 100%;
        max-width: 100%;
        pointer-events: all;
        position: relative;
        width: 470px;
    }

    .search-results-btn {
        background: none;
        border: none;
        width: 100% !important;
        padding: 0px 5px;

        .block-icon-preview-search {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            background-color: #06a9f3 !important;
            margin-right: 1rem;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
        }

        .search-results-btn-child {
            padding: 20px;
            display: flex;
            flex-direction: row;
            justify-content: start;
            text-align: center;
            align-items: center;
        }

        &:hover,
        &.selected {
            background: #f2f2f2;

            .img {
                background-color: #06a9f3 !important;
            }
        }
    }

    .search-results-btn-hovered {
        background: #f2f2f2;
    }

    .search-results-btn:hover .material-icons {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: #06a9f3;
        margin-right: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .search-results-less-char {
        background: none;
        border: none;
        width: 100% !important;
        padding: 0px 5px;

        .search-results-btn-child {
            padding: 20px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            text-align: center;
            align-items: center;
        }
    }

    .searching-results {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: start;
    }

    input {
        background: transparent;
        border: 0;
        font-size: 16px;
        font-weight: 400;
        height: 60px;
        line-height: 23px;
        padding: 0 60px;
        width: 100%;
    }

    .chatbot-btn {
        border: none;
        background: #fff;
        border-radius: 4px;
        padding: 4px 8px;
        margin: 0 1rem;
        min-height: 34px;
        min-width: 34px;
        color: #000;
        display: flex;
        align-items: center;

        &:hover {
            background: #6ca7ff;
            color: #ffffff;
        }
    }

    .material-icons {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: #c9d3de;
        margin-right: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .img-hovered {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: #06a9f3 !important;
        margin-right: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .block-name-hovered {
        color: #06a9f3 !important;
    }

    &::-webkit-scrollbar {
        display: none;
    }
}
</style>
